import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bslist-group',
	templateUrl:'./BSListGroupPluginCompPage.html',
	styles: [],
	styleUrls:['./BSListGroupPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSListGroupPluginCompPage
{
	mdContent_831 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.listgroup.BSListGroup;
\`\`\``;
	mdContent_832 = `\`\`\`java
BSListGroup()
\`\`\``;
	mdContent_833 = `\`\`\`java
BSListGroup&lt;?&gt; list = new BSListGroup&lt;&gt;();
list.addButtonItem("Action 1");
list.addButtonItem("Action 2");
list.addLinkItem("Link Item");
list.setFlush();
\`\`\``;
}
